<template>
  <div class="container-fluid">
    <div class="row mb-3 align-items-center">
      <div class="col-sm-6">
        <h3>Quản lý ngân hàng</h3>
      </div>
      <div class="col-sm-6 text-end">
        <button class="btn btn-primary" @click="openModal()">
          <vue-feather type="plus" size="14" class="me-1"></vue-feather> Thêm mới
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th>ID</th>
                <th>Tên ngân hàng</th>
                <th>Mã (BIN)</th>
                <th>Logo</th>
                <th>Số tài khoản</th>
                <th>Chủ tài khoản</th>
                <th>Loại</th>
                <th>Trạng thái</th>
                <th>Thao tác</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="bank in bankAccounts" :key="bank.id" :class="{'table-primary': bank.is_default}">
                <td>{{ bank.id }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <span>{{ bank.bank_name }}</span>
                    <span v-if="bank.is_default" class="badge bg-primary ms-2">Mặc định</span>
                  </div>
                  <small class="text-muted">{{ bank.short_name }}</small>
                </td>
                <td>{{ bank.acq_id }}</td>
                <td>
                  <img v-if="bank.logo_url" :src="bank.logo_url" alt="logo" style="height: 40px; max-width: 120px; object-fit: contain;" />
                </td>
                <td><strong>{{ bank.account_number }}</strong></td>
                <td>{{ bank.account_name }}</td>
                <td>
                  <span class="badge" :class="bank.is_company ? 'bg-warning text-dark' : 'bg-secondary'">
                    {{ bank.is_company ? 'Công ty' : 'Thông thường' }}
                  </span>
                </td>
                <td>
                  <span class="badge" :class="bank.is_active ? 'bg-success' : 'bg-danger'">
                    {{ bank.is_active ? 'Hoạt động' : 'Tạm ẩn' }}
                  </span>
                </td>
                <td>
                  <div class="d-flex gap-1 justify-content-center flex-wrap" style="max-width: 250px;">
                    <button class="btn btn-sm btn-info text-white" title="Sửa" @click="openModal(bank)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                      v-if="!bank.is_default && bank.is_active"
                      class="btn btn-sm btn-warning text-white"
                      :disabled="settingDefaultId === bank.id"
                      title="Đặt mặc định"
                      @click="handleSetDefault(bank.id)"
                    >
                      <span v-if="settingDefaultId === bank.id" class="spinner-border spinner-border-sm"></span>
                      <i v-else class="fa fa-star"></i>
                    </button>
                    <button
                      v-if="bank.is_company"
                      class="btn btn-sm btn-secondary"
                      title="Gán khách hàng"
                      @click="openAssignModal(bank)"
                    >
                      <vue-feather type="users" size="13"></vue-feather>
                    </button>
                    <button class="btn btn-sm btn-danger" title="Xóa" @click="handleDelete(bank.id)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="bankAccounts.length === 0">
                <td colspan="9" class="text-center py-3">Chưa có dữ liệu</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <BankAccountModal ref="bankModalRef" @saved="fetchData" />
    <AssignCustomersModal ref="assignModalRef" @saved="fetchData" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useBankAccounts } from '@/composables/useBankAccounts'
import BankAccountModal from './BankAccountModal.vue'
import AssignCustomersModal from './AssignCustomersModal.vue'

const { fetchBankAccountsApi, deleteBankAccountApi, setDefaultBankAccountApi } = useBankAccounts()

const bankAccounts = ref([])
const bankModalRef = ref(null)
const assignModalRef = ref(null)
const settingDefaultId = ref(null)

const fetchData = async () => {
  const response = await fetchBankAccountsApi()
  if (response.success && response.data?.data) {
    bankAccounts.value = response.data.data
  }
}

const openModal = (bank = null) => {
  if (bankModalRef.value) {
    bankModalRef.value.open(bank)
  }
}

const openAssignModal = (bank) => {
  if (assignModalRef.value) {
    assignModalRef.value.open(bank)
  }
}

const handleSetDefault = async (id) => {
  if (!confirm('Đặt ngân hàng này làm mặc định cho các thanh toán mới?')) return
  settingDefaultId.value = id
  const response = await setDefaultBankAccountApi(id)
  settingDefaultId.value = null
  if (response.success) {
    fetchData()
  } else {
    alert(response.error)
  }
}

const handleDelete = async (id) => {
  if (confirm('Bạn có chắc chắn muốn xóa ngân hàng này?')) {
    const response = await deleteBankAccountApi(id)
    if (response.success) {
      alert('Xóa thành công')
      fetchData()
    } else {
      alert(response.error)
    }
  }
}

onMounted(() => {
  fetchData()
})
</script>
